import { z } from 'zod'
import { t } from 'i18next'
import {
  EINDEUTIGE_KENNUNG_MAX_LENGTH,
  EINDEUTIGE_KENNUNG_REGEXP
} from '../../../../utils'

// Default constants
const DEFAULT_FIELD_4_11 = {
  eindeutigeKennung: ''
}

const DEFAULT_AUFTRAG_4_10 = {
  enabled: true,
  field_4_11: DEFAULT_FIELD_4_11
}

const DEFAULT_BEFEHL_4_FORM = {
  auftrag_4_10: DEFAULT_AUFTRAG_4_10
}

// Factory function
// Used to allow dynamic translation (i18next) in error messages.
export const createBefehl4FormSchema = () => {
  const Field4_11Schema = z
    .object({
      eindeutigeKennung: z
        .string()
        .max(EINDEUTIGE_KENNUNG_MAX_LENGTH)
        .regex(EINDEUTIGE_KENNUNG_REGEXP, {
          message: t('ui-validation:befehl4.format')
        })
        .or(z.literal(''))
        .default(DEFAULT_FIELD_4_11.eindeutigeKennung)
    })
    .default(() => structuredClone(DEFAULT_FIELD_4_11))

  const Auftrag4_10Schema = z
    .object({
      enabled: z.boolean().default(DEFAULT_AUFTRAG_4_10.enabled),
      field_4_11: Field4_11Schema
    })
    .default(() => structuredClone(DEFAULT_AUFTRAG_4_10))

  return z
    .object({
      auftrag_4_10: Auftrag4_10Schema
    })
    .default(() => structuredClone(DEFAULT_BEFEHL_4_FORM))
}

export const Befehl4FormSchema = createBefehl4FormSchema()

// Validation schema factory
export const createBefehl4FormValidationSchema = () => {
  return createBefehl4FormSchema()
}

export type Befehl4FormData = z.infer<
  ReturnType<typeof createBefehl4FormSchema>
>
